export default __webpack_public_path__ + "static/media/love-illustration.c759090f.svg";